import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";
import { Reveal, Label } from "@/components/motion";
import { CONTACT, IMAGES, useTitle } from "@/data/site";

export default function Contact() {
  useTitle("Contact | Plan Your Journey | Urban Trail");

  return (
    <div data-testid="contact-page">
      <PageHero
        image={IMAGES.contactHero}
        label="Contact"
        titleLines={["Let's plan your", "next journey."]}
        sub="Tell us a little about where you'd like to go, what you'd like to experience and how you'd like to travel."
        tall
      />

      <section className="bg-white">
        <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
          <div className="grid gap-20 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <Reveal>
                <Label>Start Planning</Label>
              </Reveal>
              <Reveal delay={0.08}>
                <h2 className="mb-16 mt-6 font-serif text-4xl font-light leading-[1.02] tracking-tight text-ink sm:text-5xl">
                  Tell us about your journey.
                </h2>
              </Reveal>
              <EnquiryForm />
            </div>

            <div className="lg:col-span-4 lg:col-start-9">
              <Reveal delay={0.1}>
                <div className="border border-mist p-10 lg:sticky lg:top-32 lg:p-12">
                  <p className="label text-gold">Reach Us</p>
                  <div className="mt-10 space-y-10">
                    <div>
                      <p className="label text-steel">Email</p>
                      <a
                        href={`mailto:${CONTACT.email}`}
                        data-testid="contact-email"
                        className="mt-3 block text-lg text-ink transition-colors hover:text-gold"
                      >
                        {CONTACT.email}
                      </a>
                    </div>
                    <div>
                      <p className="label text-steel">Phone</p>
                      <a
                        href={CONTACT.phoneHref}
                        data-testid="contact-phone"
                        className="mt-3 block text-lg text-ink transition-colors hover:text-gold"
                      >
                        {CONTACT.phone}
                      </a>
                    </div>
                    <div>
                      <p className="label text-steel">WhatsApp</p>
                      <a
                        href={CONTACT.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-whatsapp"
                        className="mt-3 block text-lg text-ink transition-colors hover:text-gold"
                      >
                        {CONTACT.phone}
                      </a>
                    </div>
                    <div>
                      <p className="label text-steel">Office</p>
                      <p data-testid="contact-office" className="mt-3 text-base leading-relaxed text-ink">
                        {CONTACT.office}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
